module.exports = __webpack_public_path__ + "img/document.19315a6e.svg";